import { useEffect, useState, useCallback } from 'react';
import toast from 'react-hot-toast';
import styled, { css } from 'styled-components';
import Api from '../utils/Api';
import moment from 'moment';
import FilteredList from '../components/FilteredList';
import Button from '../components/Button';
import EditUser from '../components/EditUser';

const UserListStyles = css`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 30px;
  height: 100%;
  //width: 60%;
  .listButton {
    display: flex;
    justify-content:center;
    align-items: center;
  }

`
const UserList = styled(({ className, users, onEditUser, onAddUser }) => {

  const [addUser, setAddUser] = useState(false);
  const [editUser, setEditUser] = useState(null);

  const saveUser = async ({ id, firstname, lastname, email, role, forcePWChange, forceLogin }) => {
    if (id) {
      // edit
      onEditUser({ id, firstname, lastname, email, role, forcePWChange, forceLogin });
      setEditUser(null);
    } else {
      // add
      onAddUser({ firstname, lastname, email, role })
      setAddUser(false);
    }
  }

  const columns = {
    'lastname': {
      render: user => `${user.firstname} ${user.lastname}`,
      heading: 'Name'
    },
    'email': {
      render: user => user.email,
      heading: 'Email'
    },
    'role': {
      render: user => user.role.toUpperCase(),
      heading: 'Role'
    },
    'lastLogin': {
      render: user => user.lastLogin ? moment(user.lastLogin).format('MMM DD, YYYY HH:mm:ss') : '-',
      heading: 'Last Login'
    },
    'invitedOn': {
      render: user => user.invitedOn ? moment(user.invitedOn).format('MMM DD, YYYY HH:mm:ss') : '-',
      heading: 'Invited On'
    },
    'registeredOn': {
      render: user => user.registeredOn ? moment(user.registeredOn).format('MMM DD, YYYY HH:mm:ss') : '-',
      heading: 'Registered On'
    }
  }

  return (
    <div className={className}>
      <FilteredList
        data={users}
        columns = {columns}
        filterColumns={['firstname', 'lastname', 'email', 'role']}
        initialFilter= ''
        initialSortColumn = 'lastLogin'
        initialSortDir = 'desc'
        onEditClick = {user => setEditUser(user)}
        controls={
          <>
            <Button className='listButton' onClick={() => setAddUser(true)}>+</Button>
          </>
        }
      />
      {addUser && <EditUser onConfirm={saveUser} onCancel={() => setAddUser(false)} />}
      {editUser && <EditUser user={editUser} onConfirm={saveUser} onCancel={() => setEditUser(null)} />}
      {/* {deleteFaq && <ConfirmDelete faq={deleteUser} onConfirm={() => remove(deleteUser)} onCancel={() => setDeleteUser(null)} />} */}
    </div>
  )

})`${UserListStyles}`;

const styles = css`
  display: flex;
  flex-direction:column;
  align-items: center;
  height: 100%;
  width: 100%;
  min-width: 1000px;

  & .title {
    font-size: 2rem;
    padding: 20px;
  }
`
const Users = styled(({ className }) => {

  const [users, setUsers] = useState(null);

  const fetchUsers = useCallback(async () => {
    const [err, users] = await Api.getUsers();
    if (!err) {
      setUsers(users);
    } else {
      toast.error(`Error getting users: ${Api.error(err)}`)
      console.error(err);
    }
  }, []);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  const addUser = async ({ firstname, lastname, email, role = 'developer' }) => {
    const [err,] = await Api.inviteUser({
      firstname,
      lastname,
      email,
      role,
    });
    if (!err) {
      toast.success('User invited successfully');
      fetchUsers();
    }
    else toast.error(`Error inviting user: ${Api.error(err)}`);
  }

  const updateUser = async ({ id, firstname, lastname, email, role = 'user', forcePWChange, forceLogin }) => {
    const [err,] = await Api.updateUser(id, {
      firstname,
      lastname,
      email,
      role,
      forcePWChange,
      forceLogin,
    });
    if (!err) {
      fetchUsers();
      toast.success('User updated successfully');
    }
    else toast.error(`Error updating user: ${Api.error(err)}`);
  }

  return (
    <div className={className}>
      {users && <UserList users={users} onEditUser={updateUser} onAddUser={addUser} />}
    </div>
  )
})`${styles}`

export default Users;